require('./accountMovementsView.scss');

// @vendors
const PropTypes = require('prop-types');
const React = require('react');
const { withRouter } = require('react-router-dom');
const { Component } = require('react');
const { connect } = require('react-redux');
const PureRenderMixin = require('react-addons-pure-render-mixin');

// @commons
const { formatText } = require('core/i18n').i18n;
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { getLastNChars } = require('utilities/stringHelper');
const { OKCover } = require('commonsComponents/OKCover');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const OKTag = require('components/commons/OKTag/OKTag');

// @actions
const accountTransactionsDownloadActions = require('actions/accountTransactionsDownload');
const accountsAliasActions = require('actions/postAccountAlias');
const accountsRetentionsActions = require('actions/getAccountsRetentions');
const accountsTransactionsActions = require('actions/getAccountsTransactions');
const signaturePatternActions = require('actions/signaturePattern');

// @ Loans
const { okLoansComponents } = require('ok-loans');

// @components
const LoansCreditsMoreOptionsButton = okLoansComponents.loansCreditsMoreOptionsButton;
const AccountMoreOptionsButton = require('components/accounts/accountMoreOptionsButton/accountMoreOptionsButton');
const { LoadingSection } = require('commonsComponents/loadingSection');
const AccountHeaderDetails = require('components/accounts/accountHeaderDetails/accountHeaderDetails');
const AccountRetentions = require('components/accounts/accountRetentions/accountRetentions');
const AccountLastMovements = require('components/accounts/accountLastMovements/accountLastMovements');
const TutorialLauncher = require('components/tutorial/tutorialLauncher');
import extendAccountFunctionality from 'components/accounts/extendAccountFunctionality/extendAccountFunctionality';

// @helpers
const AccessHelper = require('utilities/accessHelper');
const { sendTextToClipBoard } = require('commonsUtilities/clipBoardHelper');
const { contactCenterClassName } = require('utilities/conditionals/conditionalClassname');

// @constants
const { accountConstants } = require('utilities/accessHelperConditions/accounts');
const { GRAPHIC_TUTOR_TYPE_3 } = require('constants/index');

class AccountMovementsView extends Component {
    constructor(props) {
        super(props);

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.onPostAlias = this.onPostAlias.bind(this);
    }

    componentDidMount() {
        const { history, immAccounts, match: { params: { accountId } } } = this.props;

        AccessHelper.allowAccess(accountConstants.ACCOUNTS_MOVEMENTS, { immAccounts, accountId }, history);
    }

    componentWillUnmount() {
        this.props.clearFilters();
    }

    onPostAlias(value) {
        const { match: { params: { accountId } }, postAlias } = this.props;

        postAlias(accountId, value);
    }

    buildTooltipContent(iban) {
        return (
            <span>
                {iban}
                <button
                    className="icon__tooltip icon-copiar account-movements__tooltip-iban-icon"
                    onClick={() => sendTextToClipBoard(iban)}>
                </button>
            </span>
        );
    }

    render() {
        const {
            clearFilters,
            downloadAccountsTransactions,
            resetScaForAccountTransactionsDownload,
            flagBasedFeatures,
            immAccountTransactionsDownload,
            immAccounts,
            immAccountsRetentions,
            immAccountsTransactions,
            immProfile,
            immScreenState,
            immSignaturePatternVirtualOffices,
            match: { params: { accountId, creditType } },
            requestAccountRetentions,
            requestAccountTransactions,
            requestNextAccountRetentionsPage,
            requestNextAccountTransactionsPage,
            resetFilter,
            setFilter,
            toggleAccountMovementsScaModal,
            validateAndExecuteSagas,
            history
        } = this.props;

        const immAccount = immAccounts.getIn(['byId', accountId]);

        const tutorial = (
            <TutorialLauncher
                type={GRAPHIC_TUTOR_TYPE_3}
                title={formatText('tutorials-movementsAccountsTitle')}
            />
        );

        let sectionContent = <LoadingSection />;
        if (immAccount) {
            const titleEditable = immAccount.get('isAliasUpdating') ? immAccount.get('aliasTentative') : immAccount.get('alias');
            const isTitleEditableLong = titleEditable.length > 30;
            const subtitleLeft = immAccount.get('catalogData').get('subtype');
            const iban = immAccount.get('iban');
            const target = <span className="ok-header-sub-page__subtitle-right">{getLastNChars(iban)}</span>;
            const content = this.buildTooltipContent(iban);
            const isInactiveAccount = immAccount.get('isInactiveAccount');
            let blockedTag = null;
            if (isInactiveAccount) {
                const blockedLabel = formatText('accountsAccount-blocked');
                blockedTag = (
                    <span className="account-movements__blocked-tag">
                        <OKTag content={blockedLabel} type="warning" context="arrow" emphasis={true} />
                    </span>
                );
            }
            const subtitleRight = (
                <span>
                    <OKTooltip
                        content={content}
                        offset={[60, 15]}
                        placement="bottom"
                        target={target}
                    />
                    {blockedTag}
                </span>
            );
            const mappingBreadcrumb = [
                {
                    text: formatText('breadcrumb-accounts'),
                    url: '/myprofile/accounts'
                },
                {
                    text: immAccount.get('alias'),
                    url: ''
                }
            ];
            let moreOptionsButton;

            if (creditType) {
                moreOptionsButton = <LoansCreditsMoreOptionsButton id={accountId} type={creditType} />
            } else {
                moreOptionsButton = <AccountMoreOptionsButton accountId={accountId} onOptionClick={this.props.handleOptionsClick} />;
            }

            /**
             * We need to remove the cell separation if the retention component
             * has no content (height = 0). So we need to know when the
             * component is loading and if it has contents after loading.
             *
             * We asume it has, and we remove the padding-top of the next cell
             * if doesn't.
             *
             * @return {Boolean} There is a first cell if it is loading or if
             *                   it has contents.
             */

            const isThereAFirstCell = () => {
                const { immAccountsRetentions } = this.props;

                let retentionsSize = true;

                if (immAccountsRetentions && immAccountsRetentions.size) {
                    const retentionsByOrder = immAccountsRetentions.getIn([accountId, 'byOrder']);
                    if (retentionsByOrder) {
                        retentionsSize = Boolean(retentionsByOrder.size);
                    }
                }

                let retentionsAreLoading = immAccountsRetentions.getIn([accountId, 'loading']);

                return retentionsAreLoading || retentionsSize;
            };

            const isCanceledAccount = !!immAccount.getIn(['filters', 'canceled'])
            const accountMovementsClassname = contactCenterClassName('account-movements')
            const gridViewBodyClassname = contactCenterClassName('account-movements__body', 'grid-view__body')
            sectionContent = (
                <div className={accountMovementsClassname}>
                    <div className="container-fluid account-movements--header-identifier">
                        <div className="row">
                            <OKCover size="medium" section="accounts" customClass="col-xs-12">
                                <OKHeaderSubPage
                                    breadcrumbConfig={mappingBreadcrumb}
                                    subtitleLeft={subtitleLeft}
                                    subtitleRight={subtitleRight}
                                    titleIsEditable={!__CONTACT_CENTER__}
                                    titleEditable={titleEditable}
                                    finalTitle={__CONTACT_CENTER__ ? titleEditable : undefined}
                                    titleEditableAction={this.onPostAlias}
                                    tutorial={tutorial}
                                    isSubtitleWithTag={!!blockedTag}
                                    ellipsis={isTitleEditableLong}
                                >
                                    {!isCanceledAccount && <AccountHeaderDetails immAccount={immAccount} />}
                                    {moreOptionsButton}
                                </OKHeaderSubPage>
                            </OKCover>
                        </div>
                    </div>
                    <div className={gridViewBodyClassname}>
                        <div className="container-fluid">
                            <div className="row grid-view--content-position-negative">
                                <div className="col-md-12">
                                    <AccountRetentions
                                        accountId={accountId}
                                        immAccountsRetentions={immAccountsRetentions}
                                        immScreen={immScreenState}
                                        requestAccountRetentions={requestAccountRetentions}
                                        requestNextAccountRetentionsPage={requestNextAccountRetentionsPage}
                                    />
                                </div>
                                <div className={`col-md-12 grid-view--fix-cell-separation ${isThereAFirstCell() ? '' : 'grid-view--hide-cell-separation'}`}>
                                    <AccountLastMovements
                                        accountId={accountId}
                                        clearFilters={clearFilters}
                                        downloadAccountsTransactions={downloadAccountsTransactions}
                                        resetScaForAccountTransactionsDownload={resetScaForAccountTransactionsDownload}
                                        flagBasedFeatures={flagBasedFeatures}
                                        immAccountTransactionsDownload={immAccountTransactionsDownload}
                                        immAccountsTransactions={immAccountsTransactions}
                                        immProfile={immProfile}
                                        immSignaturePatternVirtualOffices={immSignaturePatternVirtualOffices}
                                        isCredit={!!creditType}
                                        isInactiveAccount={isInactiveAccount}
                                        requestAccountTransactions={requestAccountTransactions}
                                        requestNextAccountTransactionsPage={requestNextAccountTransactionsPage}
                                        resetFilter={resetFilter}
                                        setFilter={setFilter}
                                        toggleAccountMovementsScaModal={toggleAccountMovementsScaModal}
                                        validateAndExecuteSagas={validateAndExecuteSagas}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }

        return sectionContent;
    }
}

AccountMovementsView.propTypes = {
    clearFilters: PropTypes.func.isRequired,
    downloadAccountsTransactions: PropTypes.func.isRequired,
    resetScaForAccountTransactionsDownload: PropTypes.func.isRequired,
    flagBasedFeatures: PropTypes.object,
    history: PropTypes.object.isRequired,
    immAccountTransactionsDownload: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immAccountsRetentions: PropTypes.object.isRequired,
    immAccountsTransactions: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    immSignaturePatternVirtualOffices: PropTypes.object.isRequired,
    immScreen: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    postAlias: PropTypes.func.isRequired,
    requestAccountRetentions: PropTypes.func.isRequired,
    requestAccountTransactions: PropTypes.func.isRequired,
    requestNextAccountRetentionsPage: PropTypes.func.isRequired,
    requestNextAccountTransactionsPage: PropTypes.func.isRequired,
    resetFilter: PropTypes.func.isRequired,
    setFilter: PropTypes.func.isRequired,
    toggleAccountMovementsScaModal: PropTypes.func.isRequired,
    validateAndExecuteSagas: PropTypes.func.isRequired,
};

module.exports.constructor = AccountMovementsView;
module.exports.AccountMovementsView = connect(
    state => ({
        flagBasedFeatures: state.flagBasedFeatures,
        immAccounts: state.accounts,
        immAccountTransactionsDownload: state.accountTransactionsDownload,
        immAccountsTransactions: state.accountsTransactions,
        immAccountsRetentions: state.accountsRetentions,
        immScreenState: state.screen,
        immProfile: state.profile,
        immSignaturePatternVirtualOffices: state.signaturePatternVirtualOffices,
    }), {
    clearFilters: accountsTransactionsActions.clearAccountTransactionsFilter,
    downloadAccountsTransactions: accountTransactionsDownloadActions.downloadAccountsTransactions,
    resetScaForAccountTransactionsDownload: accountTransactionsDownloadActions.resetScaForAccountTransactionsDownload,
    postAlias: accountsAliasActions.postAccountAlias,
    requestAccountRetentions: accountsRetentionsActions.requestAccountRetentions,
    requestAccountTransactions: accountsTransactionsActions.requestAccountTransactions,
    requestNextAccountRetentionsPage: accountsRetentionsActions.requestNextAccountRetentionsPage,
    requestNextAccountTransactionsPage: accountsTransactionsActions.requestNextAccountTransactionsPage,
    resetFilter: accountsTransactionsActions.resetAccountTransactionFilter,
    setFilter: accountsTransactionsActions.setAccountTransactionsFilter,
    toggleAccountMovementsScaModal: accountsTransactionsActions.toggleAccountMovementsScaModal,
    validateAndExecuteSagas: signaturePatternActions.validateAndExecuteSagas,
})(withRouter(extendAccountFunctionality(AccountMovementsView)));
